import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button } from "react-bootstrap";
import {
  Field,
  reduxForm,
  formValueSelector,
  change as changeFieldValue,
} from "redux-form";
import { FormattedMessage, FormattedHTMLMessage, intlShape } from "react-intl";
import classNames from "classnames";
import Recaptcha from "react-recaptcha";
import config from "config";
import _ from "lodash";

import {
  TextInput,
  StyledCheckboxInput,
  CheckboxGroup,
  RadioGroup,
} from "../common/form";
import { BSModal, MessageBox, Render } from "../common";

import validationUtils from "../../utils/ValidationUtils";
import {
  WITHDRAWAL_VALIDATION_RULES,
  INSTITUTIONAL_EMAIL_VALIDATION_RULES,
  REFUND_VALIDATION_RULES,
  DESJARDINS_REFUND_VALIDATION_RULES,
} from "./withdrawalValidationRules";

import {
  MEMBER,
  CODE_VERIFICATION,
  EMAIL_VERIFICATION,
} from "./withdrawalModels";

import { FR } from "../common/enums/languages";

import {
  PERMANENT_DEACTIVATION,
  ANNUAL_DEACTIVATION,
  SESSION_DEACTIVATION,
} from "../dashboard/clients/client/members/member/coverage/enums/memberCoverageInactivityReasons";

import * as withdrawalActions from "./withdrawalActions";
import question_mark from "../../assets/images/question_mark.png";
import bank_order_fr from "../../assets/images/bank_order_fr.png";
import bank_order_en from "../../assets/images/bank_order_en.png";

let useRefundValidation = false;
let useInstitutionalEmail = false;

class WithdrawalForm extends React.Component {
  static getValidationRules(
    includeRefund = false,
    useInstitutionalEmail = false,
    values
  ) {
    let rules = { ...WITHDRAWAL_VALIDATION_RULES };

    if (includeRefund) {
      rules = { ...rules, ...REFUND_VALIDATION_RULES };
    }

    if (useInstitutionalEmail) {
      rules = { ...rules, ...INSTITUTIONAL_EMAIL_VALIDATION_RULES };
    }

    if (values.bankInstitution == "815" || values.bankInstitution == "829") {
      rules = { ...rules, ...DESJARDINS_REFUND_VALIDATION_RULES };
    }

    return rules;
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      memberIdentifier: "",
      showInformationModal: true,
      showSuccessModal: true,
      verified: !props.mustIncludeWithdrawalCode,
      verificationCodeChecked: false,
      emailIsInstitutional: !props.mustUseInstitutionEmailForWithdrawal,
      emailChecked: false,
      showInformationModalBank: false,
    };

    this.closeModal = this.closeModal.bind(this);
    this.liveCheckPIN = this.liveCheckPIN.bind(this);
    this.memberEmailCheck = this.memberEmailCheck.bind(this);
    this.renderInformationModal = this.renderInformationModal.bind(this);
    this.renderLiveCheckError = this.renderLiveCheckError.bind(this);
    this.renderSubmitMessage = this.renderSubmitMessage.bind(this);
    this.updateCaptcha = this.updateCaptcha.bind(this);
    this.verifyCode = this.verifyCode.bind(this);
    this.renderInformationModalBank = this.renderInformationModalBank.bind(
      this
    );
    this.confirmOperation = this.confirmOperation.bind(this);
  }

  componentWillMount() {
    this.updateCaptcha();
  }

  closeModal(modalName) {
    this.setState({ [modalName]: false });
  }

  generateCoverageGroups() {
    const { coverageGroups, languageCode, memberGuarantees } = this.props;

    return coverageGroups.map((group) => {
      const activeGuarantees = group.clientCoverages.filter((coverage) => {
        return memberGuarantees.includes(coverage.guaranteeId);
      });

      let guaranteeList = group.clientCoverages.map((coverage) => {
        return coverage.localizations[languageCode].name;
      });
      guaranteeList =
        guaranteeList.length > 1 ? ` (${guaranteeList.join(", ")})` : "";

      return {
        value: group.withdrawalId,
        text: group.name + guaranteeList,
        disabled: activeGuarantees.length == 0,
      };
    });
  }

  liveCheckPIN(e) {
    const {
      client: { clientId },
      billingPeriod: { billingPeriodId },
      languageCode,
      withdrawalActions,
    } = this.props;
    const memberIdentifier = e.target.value;
    if (memberIdentifier == this.state.memberIdentifier) {
      return false;
    }

    this.setState({ memberIdentifier });
    if (memberIdentifier.trim()) {
      this.props.initialize({ memberIdentifier });
      withdrawalActions.request(
        MEMBER,
        { clientId, billingPeriodId, memberIdentifier },
        { "Accept-Language": languageCode },
        {},
        MEMBER.checkFlag
      );
    } else {
      withdrawalActions.clear(MEMBER);
    }
  }

  memberEmailCheck(e) {
    const {
      client: { clientId, mustUseInstitutionEmailForWithdrawal },
      languageCode,
      memberIdentifier,
      withdrawalActions,
    } = this.props;
    const memberInstitutionEmail = e.target.value;
    if (!!mustUseInstitutionEmailForWithdrawal) {
      if (memberInstitutionEmail.trim()) {
        withdrawalActions
          .request(
            EMAIL_VERIFICATION,
            { clientId, memberIdentifier, memberInstitutionEmail },
            { "Accept-Language": languageCode }
          )
          .then((result) => {
            this.props.changeFieldValue(
              "withdrawalForm",
              "confirmInstitutionalEmail",
              result.payload.data ? memberInstitutionEmail : null
            );
            this.setState({
              emailChecked: true,
              emailIsInstitutional: result.payload.data,
            });
          });
      } else {
        withdrawalActions.clear(EMAIL_VERIFICATION);
        this.props.changeFieldValue(
          "withdrawalForm",
          "confirmInstitutionalEmail",
          null
        );
        this.setState({ emailChecked: false, emailIsInstitutional: null });
      }
    }
  }

  confirmOperation() {
    this.setState({ showInformationModalBank: true });
  }

  renderInformationModalBank() {
    let image_path_bank_order = "";
    image_path_bank_order = bank_order_en;
    if (localStorage.getItem("languageCode") == FR.value) {
      image_path_bank_order = bank_order_fr;
    }
    return (
      <div>
        <BSModal
          title=""
          closeButtonKey="common.ok"
          onClose={() => this.closeModal("showInformationModalBank")}
          show={this.state.showInformationModalBank}
        >
          <FormattedMessage id="withdrawal.form.checkSpecimenTooltip" />
          <br />
          <br />
          <img className="img" src={image_path_bank_order} />
        </BSModal>
      </div>
    );
  }

  renderLiveCheckError(errorCode) {

    if (errorCode == undefined) {
      const { checkError } = this.props;
      errorCode = `withdrawal.messages.errors.${checkError.data.error}`;
    }

    return (
      <MessageBox className="alert-danger">
        <FormattedHTMLMessage id={errorCode} />
      </MessageBox>
    );
  }

  renderSubmitMessage() {
    const { hasSubmitError, submitError } = this.props;
    if (hasSubmitError) {
      const messageKey = `withdrawal.messages.errors.${submitError.data.error}`;
      return this.renderLiveCheckError(messageKey);
    }
    return (
      <div>
        <MessageBox className="alert-success">
          <FormattedMessage id="withdrawal.messages.success" />
        </MessageBox>
        <BSModal
          title={
            <FormattedMessage id="withdrawal.messages.successModalTitle" />
          }
          closeButtonKey="common.ok"
          onClose={() => this.closeModal("showSuccessModal")}
          show={this.state.showSuccessModal}
        >
          <FormattedHTMLMessage id="withdrawal.messages.successModalBody">
            {(t) => <div dangerouslySetInnerHTML={{ __html: t }} />}
          </FormattedHTMLMessage>
        </BSModal>
      </div>
    );
  }

  renderInformationModal() {
    const { withdrawalPopupMessage, withdrawalPopupTitle } = this.props;

    return (
      <div>
        <BSModal
          title={withdrawalPopupTitle}
          closeButtonKey="common.ok"
          onClose={() => this.closeModal("showInformationModal")}
          show={this.state.showInformationModal}
        >
          <p className="pre-wrap">{withdrawalPopupMessage}</p>
        </BSModal>
      </div>
    );
  }

  updateCaptcha(value) {
    this.props.changeFieldValue(
      "withdrawalForm",
      "gRecaptchaResponse",
      value || null
    );
  }

  verifyCode(e) {
    const {
      client: { clientId },
      languageCode,
      memberIdentifier,
      withdrawalActions,
    } = this.props;
    const verificationCode = e.target.value;

    if (verificationCode.trim()) {
      withdrawalActions
        .request(
          CODE_VERIFICATION,
          { clientId, memberIdentifier, verificationCode },
          { "Accept-Language": languageCode }
        )
        .then((result) => {
          this.props.changeFieldValue(
            "withdrawalForm",
            "verificationResponse",
            result.payload.data || null
          );
          this.setState({
            verificationCodeChecked: true,
            verified: result.payload.data,
          });
        });
    } else {
      this.props.changeFieldValue(
        "withdrawalForm",
        "verificationResponse",
        null
      );
    }
  }

  render() {
    const {
      client: {
        hasAnnualWithdrawalForm,
        mustIncludeWithdrawalCode,
        hasWithdrawalRefund,
        hasPermanentWithdrawalForm,
        mustUseInstitutionEmailForWithdrawal,
        hasSessionWithdrawalForm,
      },
      error = {},
      handleSubmit,
      hasCheckError,
      hasWithdrawalPopupMessage,
      isInactiveReason,
      languageCode,
      liveCheckComplete,
      member,
      memberGuarantees,
      refundMethod,
      showForm,
      submitComplete,
      submitFailed,
      submitting,
      withdrawalTypes,
      billingPeriod,
    } = this.props;

    const {
      showInformationModal,
      verificationCodeChecked,
      verified,
      showInformationModalBank,
    } = this.state;

    const disableForm = submitComplete || submitting;
    const atFields = [
      "address",
      "city",
      "postalCode",
      "relationships.country.object.countryCode",
      `relationships.country.object.localizations.${languageCode}.name`,
      `relationships.province.object.localizations.${languageCode}.name`,
    ];
    const [address, city, postalCode, countryCode, country, province] = _.at(
      member,
      atFields
    );
    const memberAddress =
      countryCode != "CA" || !address
        ? {}
        : { address, city, postalCode, country, province };
    const memberAddressMessageKey = !!memberAddress.address
      ? "withdrawal.form.refundAddress"
      : "withdrawal.form.noLocalAddress";

    const verificationCodeClasses = classNames({
      "verification-code": true,
      valid: this.state.verified && this.state.verificationCodeChecked,
      invalid: !this.state.verified && this.state.verificationCodeChecked,
    });

    const memberIdentifierClasses = classNames({
      "member-identifier": true,
      valid: liveCheckComplete && !hasCheckError,
      invalid: liveCheckComplete && !!hasCheckError,
    });

    const memberEmailClasses = classNames({
      "member-email": true,
      valid: this.state.emailIsInstitutional && this.state.emailChecked,
      invalid: !this.state.emailIsInstitutional && this.state.emailChecked,
    });
    const isDisable = refundMethod !== "DEPOSIT_REFUND" || disableForm;
    const notAnnualOrSession =
      isInactiveReason !== ANNUAL_DEACTIVATION.value &&
      isInactiveReason !== SESSION_DEACTIVATION.value;

    return (
      <form onSubmit={handleSubmit}>
        <Field
          groupClassName={memberIdentifierClasses}
          id="memberIdentifier"
          name="memberIdentifier"
          component={TextInput}
          label={<FormattedMessage id="withdrawal.form.memberIdentifier" />}
          props={{
            onBlur: this.liveCheckPIN,
            onKeyDown: (e) => {
              if (e.which == 13) {
                e.preventDefault();
                this.liveCheckPIN(e);
              }
            },
          }}
          disabled={disableForm}
        />
        {showForm && (
          <div>
            <Field
              groupClassName={memberEmailClasses}
              id="memberEmail"
              name="memberEmail"
              component={TextInput}
              label={
                <FormattedMessage
                  id={
                    mustUseInstitutionEmailForWithdrawal
                      ? "withdrawal.form.institutionEmail"
                      : "withdrawal.form.memberEmail"
                  }
                />
              }
              props={{
                onBlur: this.memberEmailCheck,
                onKeyDown: (e) => {
                  if (e.which == 13) {
                    e.preventDefault();
                    this.memberEmailCheck(e);
                  }
                },
              }}
              disabled={disableForm}
            />
            {(mustUseInstitutionEmailForWithdrawal && (
              <Field
                name="confirmInstitutionalEmail"
                component={() => <span />}
              />
            )) || (
              <Field
                id="confirmEmail"
                name="confirmEmail"
                component={TextInput}
                label={<FormattedMessage id="withdrawal.form.confirmEmail" />}
                disabled={disableForm}
              />
            )}
            {(hasAnnualWithdrawalForm ||
              hasPermanentWithdrawalForm ||
              hasSessionWithdrawalForm) && (
              <div className="section">
                <h3>
                  <FormattedMessage id="withdrawal.form.withdrawalInformationTitle" />
                </h3>
                <p>
                  <FormattedMessage id="withdrawal.form.withdrawalInformationTypes" />
                </p>
                <ul>
                  {hasPermanentWithdrawalForm && (
                    <li>
                      <FormattedMessage id="withdrawal.form.withdrawalInformationPermanent" />
                    </li>
                  )}
                  {hasAnnualWithdrawalForm && (
                    <li>
                      <FormattedMessage id="withdrawal.form.withdrawalInformationAnnual" />
                    </li>
                  )}
                  {hasSessionWithdrawalForm && (
                    <li>
                      <FormattedMessage
                        id="withdrawal.form.withdrawalInformationSession"
                        values={{
                          billingPeriod:
                            billingPeriod.localizations[languageCode],
                        }}
                      />
                    </li>
                  )}
                </ul>
              </div>
            )}
            <div className="section">
              <Field
                groupClassName="withdrawal-type-selection"
                id="isInactiveReason"
                name="isInactiveReason"
                component={RadioGroup}
                radios={withdrawalTypes}
                disabled={disableForm}
              />
              {(hasAnnualWithdrawalForm || hasSessionWithdrawalForm) && (
                <Field
                  groupClassName={classNames({
                    "withdrawal-coverage-groups": true,
                    disabled: notAnnualOrSession,
                  })}
                  disabled={notAnnualOrSession || disableForm}
                  id="withdrawalCoveragesSelection"
                  name="withdrawalCoveragesSelection"
                  component={CheckboxGroup}
                  checkboxes={this.generateCoverageGroups()}
                />
              )}
            </div>

            {mustIncludeWithdrawalCode && (
              <div className="section">
                <Field
                  groupClassName={verificationCodeClasses}
                  id="verificationCode"
                  name="verificationCode"
                  component={TextInput}
                  label={
                    <FormattedMessage id="withdrawal.form.verificationCode" />
                  }
                  props={{
                    onBlur: this.verifyCode,
                    onKeyDown: (e) => {
                      if (e.which == 13) {
                        e.preventDefault();
                        this.verifyCode(e);
                      }
                    },
                  }}
                  disabled={disableForm}
                />
                <Field name="verificationResponse" component={() => <span />} />
              </div>
            )}

            <Render
              if={
                !mustIncludeWithdrawalCode ||
                (verificationCodeChecked && verified)
              }
            >
              {hasWithdrawalRefund && (
                <div className="section">
                  <MessageBox className="alert-warning bg-transparent">
                    <FormattedMessage id="withdrawal.form.refundWarning" />
                  </MessageBox>
                  <Button className="button" onClick={this.confirmOperation}>
                    <img className="icon-size" src={question_mark} />
                  </Button>
                  {error.refundMethod && submitFailed && (
                    <MessageBox className="alert-danger simple">
                      <FormattedMessage id={error.refundMethod.messageKey} />
                    </MessageBox>
                  )}
                  <Field
                    groupClassName="withdrawal-type-selection"
                    id="refundMethod"
                    name="refundMethod"
                    component={RadioGroup}
                    radios={[
                      {
                        value: "DEPOSIT_REFUND",
                        key: "withdrawal.form.refundDeposit",
                      },
                    ]}
                    disabled={disableForm}
                  />
                  <div className="bank-fields">
                    <p className="title">
                      <FormattedMessage id="withdrawal.form.refundFields" />
                    </p>
                    <div className="fields">
                      <Field
                        id="bankTransit"
                        name="bankTransit"
                        component={TextInput}
                        type="absNumber"
                        maxLength="5"
                        disabled={isDisable}
                        label={
                          <FormattedMessage id="withdrawal.form.transitNumber" />
                        }
                      />
                      <Field
                        id="bankInstitution"
                        name="bankInstitution"
                        component={TextInput}
                        type="absNumber"
                        maxLength="3"
                        disabled={isDisable}
                        label={
                          <FormattedMessage id="withdrawal.form.institutionNumber" />
                        }
                      />
                      <Field
                        id="bankAccount"
                        name="bankAccount"
                        component={TextInput}
                        type="absNumber"
                        maxLength="12"
                        disabled={isDisable}
                        label={
                          <FormattedMessage id="withdrawal.form.accountNumber" />
                        }
                      />
                    </div>
                    <Field
                      id="bankAccountOwnerName"
                      name="bankAccountOwnerName"
                      component={TextInput}
                      type="text"
                      maxLength="64"
                      disabled={isDisable}
                      label={
                        <FormattedMessage id="withdrawal.form.bankAccountOwnerName" />
                      }
                    />
                    <Field
                      id="bankAccountOwner"
                      name="bankAccountOwner"
                      component={StyledCheckboxInput}
                      checkbox={{ value: true }}
                      label={
                        <FormattedMessage id="withdrawal.form.conditions.bankAccountOwner" />
                      }
                      disabled={isDisable}
                    />
                    <Field
                      id="correctBankInfo"
                      name="correctBankInfo"
                      component={StyledCheckboxInput}
                      checkbox={{ value: true }}
                      label={
                        <FormattedMessage id="withdrawal.form.conditions.correctBankInfo" />
                      }
                      disabled={isDisable}
                    />
                  </div>

                  <Field
                    groupClassName="withdrawal-type-selection"
                    id="refundMethod"
                    name="refundMethod"
                    component={RadioGroup}
                    radios={[
                      {
                        value: "CHEQUE_REFUND",
                        key: "withdrawal.form.refundCheck",
                      },
                    ]}
                    disabled={disableForm}
                  />
                  <FormattedHTMLMessage
                    id={memberAddressMessageKey}
                    values={memberAddress}
                  >
                    {(t) => (
                      <div
                        className="refund-address"
                        dangerouslySetInnerHTML={{ __html: t }}
                      />
                    )}
                  </FormattedHTMLMessage>
                </div>
              )}

              <div className="section">
                <FormattedMessage id="withdrawal.form.conditions.byWithdrawing" />
                <Field
                  id="haveRead"
                  name="haveRead"
                  component={StyledCheckboxInput}
                  checkbox={{ value: true }}
                  label={
                    <FormattedMessage id="withdrawal.form.conditions.haveRead" />
                  }
                  disabled={disableForm}
                />
                <Field
                  id="acceptance"
                  name="acceptance"
                  component={StyledCheckboxInput}
                  checkbox={{ value: true }}
                  label={
                    <FormattedHTMLMessage id="withdrawal.form.conditions.acceptance" />
                  }
                  disabled={disableForm}
                />
                <Field
                  id="legalUnbinding"
                  name="legalUnbinding"
                  component={StyledCheckboxInput}
                  checkbox={{ value: true }}
                  label={
                    <FormattedMessage id="withdrawal.form.conditions.legalUnbinding" />
                  }
                  disabled={disableForm}
                />
                {hasPermanentWithdrawalForm && (
                  <Field
                    id="understanding"
                    name="understanding"
                    component={StyledCheckboxInput}
                    checkbox={{ value: true }}
                    label={
                      <FormattedMessage id="withdrawal.form.conditions.understanding" />
                    }
                    disabled={disableForm}
                  />
                )}
                <Field
                  id="withdrawFromTheRegime"
                  name="withdrawFromTheRegime"
                  component={StyledCheckboxInput}
                  checkbox={{ value: true }}
                  label={
                    <FormattedMessage id="withdrawal.form.conditions.withdrawFromTheRegime" />
                  }
                  disabled={disableForm}
                />
              </div>

              <div className="section">
                <Recaptcha
                  sitekey={config.recaptchaApiKey}
                  render="explicit"
                  expiredCallback={this.updateCaptcha}
                  verifyCallback={this.updateCaptcha}
                  onloadCallback={() => {
                    /*will not load if this is not defined*/
                  }}
                />
                {error.gRecaptchaResponse && submitFailed && (
                  <MessageBox className="alert-danger simple">
                    <FormattedMessage
                      id={error.gRecaptchaResponse.messageKey}
                    />
                  </MessageBox>
                )}
                <Field name="gRecaptchaResponse" component={() => <span />} />
              </div>
              <div className="section">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={disableForm}
                >
                  <FormattedMessage id="withdrawal.form.submit" />
                </button>
                {submitting && <span className="loader" />}
              </div>
            </Render>
          </div>
        )}
        {hasCheckError && this.renderLiveCheckError()}
        {submitComplete && this.renderSubmitMessage()}
        {hasWithdrawalPopupMessage &&
          memberGuarantees.length > 0 &&
          showInformationModal &&
          this.renderInformationModal()}
        {showInformationModalBank && this.renderInformationModalBank()}
      </form>
    );
  }
}

WithdrawalForm.propTypes = {
  billingPeriod: PropTypes.object,
  changeFieldValue: PropTypes.func,
  checkError: PropTypes.object,
  error: PropTypes.object,
  hasCheckError: PropTypes.bool,
  hasSubmitError: PropTypes.bool,
  client: PropTypes.object,
  clientName: PropTypes.string,
  coverageGroups: PropTypes.array,
  handleSubmit: PropTypes.func,
  hasWithdrawalPopupMessage: PropTypes.bool,
  initialize: PropTypes.func,
  isInactiveReason: PropTypes.string,
  languageCode: PropTypes.string,
  liveCheckComplete: PropTypes.bool,
  member: PropTypes.object,
  memberGuarantees: PropTypes.array,
  memberIdentifier: PropTypes.string,
  mustIncludeWithdrawalCode: PropTypes.bool,
  mustUseInstitutionEmailForWithdrawal: PropTypes.bool,
  refundMethod: PropTypes.string,
  showForm: PropTypes.bool,
  submitComplete: PropTypes.bool,
  submitError: PropTypes.object,
  submitFailed: PropTypes.bool,
  submitting: PropTypes.bool,
  verificationResponse: PropTypes.object,
  withdrawalActions: PropTypes.object,
  withdrawalPopupMessage: PropTypes.string,
  withdrawalPopupTitle: PropTypes.string,
  withdrawalTypes: PropTypes.array,
};

WithdrawalForm.contextTypes = {
  intl: intlShape,
};

function mapStateToProps(state, ownProps) {
  const selector = formValueSelector("withdrawalForm");
  const { client } = ownProps;
  const liveCheck = state.withdrawal.liveCheck || {};
  const withdrawing = state.withdrawal.withdrawing || {};
  const nonBlockingSubmitErrors = ["recaptchaFailed", "wrongVerificationCode"];
  let withdrawalTypes = [];

  const hasBlockingSubmitError =
    !!withdrawing.error &&
    !nonBlockingSubmitErrors.includes(withdrawing.error.data.error);

  if (client.hasPermanentWithdrawalForm) {
    withdrawalTypes.push({
      ...PERMANENT_DEACTIVATION,
      key: "withdrawal.form.permanentWithdrawal",
    });
  }
  if (client.hasAnnualWithdrawalForm) {
    withdrawalTypes.push({
      ...ANNUAL_DEACTIVATION,
      key: "withdrawal.form.annualWithdrawal",
    });
  }
  if (client.hasSessionWithdrawalForm) {
    withdrawalTypes.push({
      ...SESSION_DEACTIVATION,
      key: "withdrawal.form.sessionWithdrawal",
    });
  }

  useRefundValidation = client.hasWithdrawalRefund;
  useInstitutionalEmail = client.mustUseInstitutionEmailForWithdrawal;

  return {
    checkError: liveCheck.error || {},
    hasCheckError: !!liveCheck.error,
    hasSubmitError: !!withdrawing.error,
    isInactiveReason: selector(state, "isInactiveReason"),
    liveCheckComplete: liveCheck.loaded,
    member: liveCheck.member || {},
    memberGuarantees: liveCheck.guaranteeIds || [],
    memberIdentifier: selector(state, "memberIdentifier"),
    refundMethod: selector(state, "refundMethod"),
    showForm: !liveCheck.error && !!liveCheck.loaded && !hasBlockingSubmitError,
    submitComplete: !!withdrawing.completed,
    submitError: withdrawing.error || {},
    submitting: !!withdrawing.submitting,
    verificationResponse: state.withdrawal.codeVerification || {},
    withdrawalTypes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    withdrawalActions: bindActionCreators(withdrawalActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true,
})(
  reduxForm({
    form: "withdrawalForm",
    validate: (values) =>
      validationUtils.validate(
        values,
        WithdrawalForm.getValidationRules(
          useRefundValidation,
          useInstitutionalEmail,
          values
        )
      ),
  })(WithdrawalForm)
);



// WEBPACK FOOTER //
// ./src/components/withdrawal/WithdrawalForm.js